import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../languages";
import ViewCart from "./ViewCart";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../store/userSlice";
import Swal from "sweetalert2";
import EventEnquiry from "./EventEnquiry";
import Globalsearch from "./Globalsearch";
import { useEffect, useState } from "react";
import { Modal } from "bootstrap";
import { setCart } from "../store/cartSlice";
import { callAPIWithoutAuth } from "../utils/apiUtils";
import { apiUrls } from "../utils/apiUrls";

function Header() {
  const { language, setLanguage } = useLanguage();
  const t = translations[language];
  const [eventtype, seteventtype] = useState("");
   const [eventname, seteventname] = useState("");
  const [promotion, setPromotion] = useState([]);
  const [pages, setPage] = useState([]);
  const [eventlist, seteventlist] = useState([]);
  const token = localStorage.getItem("accessToken");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = async () => {
    const result = await Swal.fire({
      title: t.logout,
      text: t.logout_confirm,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t.logout,
      cancelButtonText: t.cancel,
    });

    if (!result.isConfirmed) return;
    dispatch(
      setCart({
        count: 0,
      }),
    );
    localStorage.setItem("cart_count", 0);
    localStorage.removeItem("userData");
    localStorage.removeItem("accessToken");
    dispatch(logoutUser());
    navigate(`/`);
  };

  const user = useSelector((state) => state.user.user);
  const users = JSON.parse(localStorage.getItem("userData"));

  const cartCount = useSelector((state) => state.cart.cartCount);
  const cart_count = localStorage.getItem("cart_count");
  const openModal = (item,name) => {
    seteventtype(item);
    seteventname(name)
    setTimeout(() => {
      const modalElement = document.getElementById("EventEnquiryModal");
      const modal = new Modal(modalElement);
      modal.show();
    }, 0);
  };

  const promotionlist = async () => {
    try {
      const apiResponse = await callAPIWithoutAuth(
        apiUrls.announcements,
        {},
        "GET",
        {},
      );

      if (apiResponse?.data?.success) {
        setPromotion(apiResponse?.data?.data || []);
        setPage(apiResponse?.data?.pages || [])
      } else {
        setPromotion([]);
      }
    } catch (error) {
      setPromotion([]);
    }
  };

  const Geteventlist = async () => {
    try {
      const apiResponse = await callAPIWithoutAuth(
        apiUrls.eventlisting,
        {},
        "GET",
        {},
      );

      if (apiResponse?.data?.success) {
        seteventlist(apiResponse?.data?.data || []);
      } else {
        seteventlist([]);
      }
    } catch (error) {
      seteventlist([]);
    }
  };

  useEffect(() => {
    promotionlist();
    Geteventlist();
    // eslint-disable-next-line
  }, []);
  const closeNavbar = () => {
    const navbar = document.getElementById("navbarSupportedContent");

    if (navbar.classList.contains("show")) {
      const bsCollapse = window.bootstrap.Collapse.getInstance(navbar);

      if (bsCollapse) {
        bsCollapse.hide();
      }
    }
  };
  return (
    <header>
      {promotion?.length > 0 && (
        <div className="top_header">
          <div className="marquee">
            <div className="marquee-content">
              {[...promotion, ...promotion]?.map((item, index) => (
                <span
                  key={index}
                  className="d-flex align-items-center font--15 me-5"
                >
                  <img
                    src="/image/logo.png"
                    alt=""
                    className="me-2"
                    width={26}
                    height={22}
                  />

                  {language === "en" ? item?.title_en : item?.title_ja}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="header-middle">
        <div className="container-fluid space_container">
          <div className="d-flex justify-content-between align-items-center">
            <Link to={"/"} className="logo-sec">
              <img alt="" src="/image/logo.png" />
            </Link>
            <Globalsearch t={t} />
            <div className="right-menu pt-40">
              <div className="d-flex align-items-center justify-content-end">
                <div className="dropdown">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src="/image/globe.svg" alt="globe" className="me-2" />
                    {language === "en" ? "ENG" : "JPN"}
                    <img src="/image/angle-down.svg" alt="" className="ms-2" />
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => setLanguage("en")}
                      >
                        ENG
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => setLanguage("jpn")}
                      >
                        JPN
                      </button>
                    </li>
                  </ul>
                </div>
                {/* <Link
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  className="header-menu text-decoration-none d-md-none d-block"
                  to="/"
                  data-discover="true"
                >
                  <span className="header-menu-icon me-2">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.9008 18.5992L16.5 15.2258C17.8201 13.5799 18.4594 11.4907 18.2864 9.38785C18.1134 7.28502 17.1414 5.32838 15.5701 3.92025C13.9988 2.51213 11.9477 1.75955 9.83852 1.81726C7.72937 1.87497 5.7225 2.73859 4.23055 4.23054C2.7386 5.72249 1.87498 7.72936 1.81727 9.83851C1.75955 11.9477 2.51213 13.9987 3.92026 15.5701C5.32839 17.1414 7.28503 18.1134 9.38786 18.2864C11.4907 18.4594 13.5799 17.8201 15.2258 16.5L18.5992 19.8733C18.6844 19.9592 18.7858 20.0274 18.8975 20.074C19.0092 20.1205 19.129 20.1445 19.25 20.1445C19.371 20.1445 19.4908 20.1205 19.6025 20.074C19.7142 20.0274 19.8156 19.9592 19.9008 19.8733C20.0661 19.7024 20.1584 19.474 20.1584 19.2362C20.1584 18.9985 20.0661 18.7701 19.9008 18.5992ZM10.0833 16.5C8.81424 16.5 7.57364 16.1237 6.51843 15.4186C5.46321 14.7135 4.64077 13.7114 4.15511 12.5389C3.66945 11.3664 3.54238 10.0762 3.78997 8.8315C4.03755 7.58679 4.64868 6.44345 5.54607 5.54606C6.44346 4.64867 7.5868 4.03755 8.83151 3.78996C10.0762 3.54237 11.3664 3.66944 12.5389 4.1551C13.7114 4.64076 14.7135 5.4632 15.4186 6.51842C16.1237 7.57364 16.5 8.81423 16.5 10.0833C16.5 11.7851 15.824 13.4172 14.6206 14.6206C13.4172 15.824 11.7851 16.5 10.0833 16.5Z"
                        fill="#555555"
                      />
                    </svg>
                  </span>
                </Link> */}
                <Link
                  className="header-menu text-decoration-none cart "
                  data-discover="true"
                  to="#offcanvasExample"
                  data-bs-toggle="offcanvas"
                  aria-controls="offcanvasExample"
                >
                  <span className="header-menu-icon me-2 position-relative">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.5136 21.5H8.16579C5.09943 21.5 2.74703 20.3924 3.41522 15.9348L4.19325 9.89359C4.60515 7.66934 6.02392 6.81808 7.26877 6.81808H17.4473C18.7104 6.81808 20.0468 7.73341 20.5228 9.89359L21.3008 15.9348C21.8683 19.889 19.58 21.5 16.5136 21.5Z"
                        stroke="#000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.651 6.5984C16.651 4.21232 14.7167 2.27803 12.3306 2.27803V2.27803C11.1816 2.27316 10.078 2.72619 9.26381 3.53695C8.44963 4.3477 7.99193 5.44939 7.99194 6.5984H7.99194"
                        stroke="#000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.2962 11.1018H15.2505"
                        stroke="#000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.46566 11.1018H9.41989"
                        stroke="#000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="header-menu-cart-count">
                      {cartCount ? cartCount : cart_count}
                    </span>
                  </span>
                  <span className="header-meny-text">{t.cart} </span>
                </Link>
                {!token ? (
                  <Link
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    className="header-menu text-decoration-none"
                    to="#"
                    data-discover="true"
                  >
                    <span className="header-menu-icon me-2">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.889 12.6187H11.921C14.849 12.6187 17.23 10.2377 17.23 7.30971C17.23 4.38171 14.849 1.99971 11.921 1.99971C8.99202 1.99971 6.61002 4.38171 6.61002 7.30671C6.60002 10.2267 8.96702 12.6097 11.889 12.6187ZM8.03802 7.30971C8.03802 5.16871 9.78002 3.42771 11.921 3.42771C14.061 3.42771 15.802 5.16871 15.802 7.30971C15.802 9.44971 14.061 11.1917 11.921 11.1917H11.892C9.76002 11.1837 8.03102 9.44371 8.03802 7.30971Z"
                          fill="#000"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4 18.173C4 21.87 9.962 21.87 11.921 21.87C15.32 21.87 19.84 21.489 19.84 18.193C19.84 14.496 13.88 14.496 11.921 14.496C8.521 14.496 4 14.877 4 18.173ZM5.5 18.173C5.5 16.728 7.66 15.996 11.921 15.996C16.181 15.996 18.34 16.735 18.34 18.193C18.34 19.638 16.181 20.37 11.921 20.37C7.66 20.37 5.5 19.631 5.5 18.173Z"
                          fill="#000"
                        />
                      </svg>
                    </span>
                    <span className="header-meny-text">{t.signIn}</span>
                  </Link>
                ) : (
                  <div className="d-flex align-items-center text-white nav-right gap-2">
                    {/* <div
                      className="notfication-box position-relative"
                      style={{ cursor: "pointer" }}
                    >
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_163_2280"
                          maskUnits="userSpaceOnUse"
                          x={3}
                          y={1}
                          width={19}
                          height={18}
                          style={{ maskType: "luminance" }}
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M3.00012 1H21.497V18.348H3.00012V1Z"
                            fill="white"
                          />
                        </mask>
                        <g mask="url(#mask0_163_2280)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.2471 2.5C8.75214 2.5 6.31614 5.238 6.31614 7.695C6.31614 9.774 5.73914 10.735 5.22914 11.583C4.82014 12.264 4.49714 12.802 4.49714 13.971C4.66414 15.857 5.90914 16.848 12.2471 16.848C18.5501 16.848 19.8341 15.813 20.0001 13.906C19.9971 12.802 19.6741 12.264 19.2651 11.583C18.7551 10.735 18.1781 9.774 18.1781 7.695C18.1781 5.238 15.7421 2.5 12.2471 2.5ZM12.2471 18.348C7.57114 18.348 3.34514 18.018 3.00014 14.035C2.99714 12.387 3.50014 11.549 3.94414 10.811C4.39314 10.063 4.81614 9.358 4.81614 7.695C4.81614 4.462 7.80213 1 12.2471 1C16.6921 1 19.6781 4.462 19.6781 7.695C19.6781 9.358 20.1011 10.063 20.5501 10.811C20.9941 11.549 21.4971 12.387 21.4971 13.971C21.1481 18.018 16.9231 18.348 12.2471 18.348Z"
                            fill="black"
                          />
                        </g>
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.1984 22.5001H12.1964C11.0754 22.4991 10.0144 22.0051 9.20939 21.1081C8.93239 20.8011 8.95739 20.3261 9.26539 20.0501C9.57339 19.7721 10.0474 19.7971 10.3244 20.1061C10.8424 20.6831 11.5074 21.0001 12.1974 21.0001H12.1984C12.8914 21.0001 13.5594 20.6831 14.0784 20.1051C14.3564 19.7981 14.8304 19.7731 15.1374 20.0501C15.4454 20.3271 15.4704 20.8021 15.1934 21.1091C14.3854 22.0061 13.3224 22.5001 12.1984 22.5001Z"
                          fill="black"
                        />
                      </svg>
                      <span className="notify-count">0</span>
                    </div> */}
                    <div className="dropdown header-profile-dropdown">
                      <button
                        className="border-0 bg-transparent p-0"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          alt="User"
                          className="user-profile-img"
                          src={
                            user?.image_url ||
                            users?.image_url ||
                            "/image/default.png"
                          }
                        />
                      </button>
                      <ul className="dropdown-menu dropdown-menu-end">
                        <li>
                          <button
                            className="text-dark dropdown-item"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(`/dashboard`)}
                          >
                            {" "}
                          {t.my_profile}
                          </button>
                        </li>
                        <li>
                          <hr className="dropdown-divider" />
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={handleLogout}
                          >
                              {t.logout}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom_nav">
        <nav className="navbar navbar-expand-lg p-0">
          <div className="container-fluid space_container ">
            <button
              className="navbar-toggler font--14 ps-0 pe-0 border-0 d-flex d-lg-none align-items-center gap-1"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
              <span className="text-white d-lg-none d-inline-block">
                {t.menu}
              </span>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link className="nav-link" to="/" onClick={closeNavbar}>
                    {t.home}
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/menu?type=Regular"
                    onClick={closeNavbar}
                  >
                    {t.menu}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/menu?type=Bento"
                    onClick={closeNavbar}
                  >
                    {t.Bento}
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/restaurant"
                    onClick={closeNavbar}
                  >
                    {t.restaurant}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/food-truck"
                    onClick={closeNavbar}
                  >
                    {t.foodTruck}
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/delivery"
                    onClick={closeNavbar}
                  >
                    {t.Delivery}
                  </Link>
                </li>
                 {pages?.some((page) => page.slug === "about-us") && (
                <li className="nav-item">
                  <Link className="nav-link" to="/about" onClick={closeNavbar}>
                    {t.about}
                  </Link>
                </li>
                )}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/contact"
                    onClick={closeNavbar}
                  >
                    {t.contact}
                  </Link>
                </li>
              {pages?.some((page) => page.slug === "alis-group") && (
                 <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/alisgroup"
                    onClick={closeNavbar}
                  >
                    {t.AliGroup}
                  </Link>
                </li>
                )}
               <li className="nav-item d-lg-none">
                  <Link
                    className="nav-link"
                    to="/blog"
                    onClick={closeNavbar}
                  >
                    {t.blog}
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div className="d-flex"  data-bs-toggle="modal"
                data-bs-target="#EventEnquiryModal">
              <Link className="nav-link contact_us" to="#">
                {t.eventEnquiry}
              </Link>
            </div> */}
            {eventlist?.length > 0 && (
            <div class="dropdown event-drobdown">
              <button
                class="nav-link contact_us dropdown-toggle event-drobdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {t.eventEnquiry}
              </button>
              <ul class="dropdown-menu">
                {eventlist?.map((val) => (
                  <li onClick={() => openModal(val.id,language === "en" ? val?.name : val?.name_ja)} key={val.id}>
                    <Link class="dropdown-item" to="#">
                      {language === "en" ? val?.name : val?.name_ja}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            )}
          </div>
        </nav>
      </div>
      <ViewCart />
      {eventtype && <EventEnquiry eventtype={eventtype} eventname={eventname}/>}
    </header>
  );
}

export default Header;
